import {
  BULK_UPLOAD_START,
  BULK_UPLOAD_SUCCESS,
  BULK_UPLOAD_FAIL,
  BULK_SUMMARY_SUCCESS,
  BULK_SUMMARY_FAIL,
  BULK_TASK_STATUS_UPDATE,
  BULK_TASKS_LIST_SUCCESS,
  BULK_TASKS_LIST_FAIL,
  BULK_RESET,
} from "./actionTypes";

const INIT_STATE = {
  uploading: false,
  loading: false,
  taskId: null,
  taskStatus: null,
  validationErrors: [],
  summary: null,
  tasks: [],
  selectedTask: null,
  error: null,
};

const BulkSchedule = (state = INIT_STATE, action) => {
  switch (action.type) {
    case BULK_UPLOAD_START:
      return { ...state, uploading: true, error: null, taskId: null, taskStatus: null };

    case BULK_UPLOAD_SUCCESS:
      return { ...state, uploading: false, taskId: action.payload.task_id ?? action.payload.id ?? null, taskStatus: "validating" };

    case BULK_UPLOAD_FAIL:
      return { ...state, uploading: false, error: action.payload };

    case BULK_TASK_STATUS_UPDATE:
      return {
        ...state,
        taskStatus: action.payload.status,
        validationErrors: action.payload.validationErrors ?? state.validationErrors,
      };

    case BULK_SUMMARY_SUCCESS:
      return { ...state, loading: false, summary: action.payload };

    case BULK_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload };

    case BULK_TASKS_LIST_SUCCESS:
      return { ...state, loading: false, tasks: action.payload };

    case BULK_TASKS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case BULK_RESET:
      return { ...INIT_STATE };

    default:
      return state;
  }
};

export default BulkSchedule;
